define('home/models/Notifications',[
    'backbone',

    'home/models/Feed',
    'home/collections/NotificationCollection',
    'home/collections/TimelineFiltersCollection',
    'home/models/FollowRecommendationFeed',
], function (
    Backbone,

    Feed,
    NotificationCollection,
    TimelineFiltersCollection,
    FollowRecommendationFeed
) {
    'use strict';

    var Session;

    var Notifications = Backbone.Model.extend({

        initialize: function (attrs) {
            this.session = attrs.session;

            var timeComparator = function (notification) {
                // Sort notifications by time descending
                return -1 * new Date(notification.get('published')).getTime();
            };

            this.all = new Feed({}, {
                collectionClass: NotificationCollection,
                collectionOptions: {
                    comparator: timeComparator,
                    type: 'notifications',
                },
            });
            this.replies = new Feed({}, {
                collectionClass: NotificationCollection,
                collectionOptions: {
                    comparator: timeComparator,
                    type: 'notifications',
                    index: 'replies',
                },
            });

            this.interestingForums = FollowRecommendationFeed.createForumFollowRecommendationFeed();
            this.interestingUsers = FollowRecommendationFeed.createUserFollowRecommendationFeed();

            this.unreadCounter = this.all.items.unreadCounter;
            this.filters = new TimelineFiltersCollection();

            this.listenTo(this.all, 'clearUnreadCount', this.clearUnreadCount);
        },

        // Fetch recommendations needed for notifications view
        ensureFetchedRecommendations: function () {
            this.interestingForums.ensureFetched();
            this.interestingUsers.ensureFetched();
        },

        // This should only contain fetches useful across all pages (ex: unread count)
        // It should not fetch things needed only on the notifications page, since this
        // is called upon app initialization.
        ensureFetched: function () {
            // Lazy load Session to prevent circular dependency
            if (!Session)
                Session = require('home/models/Session');

            // If the user isn't logged in then we
            // definitely don't have any notifications
            // to fetch.
            if (Session.isKnownToBeLoggedOut() ||

                // Also, don't fetch if already fetched
                this.all.fetched)
                return;

            this.unreadCounter.fetch({
                initializeOnly: true,
            });
            this.all.fetchItems();
        },

        /**
         * Updates the backend readPosition so that future
         * calls will mark all the currently-showing notifications as read.
         * Does not visually mark items already in the UI as read.
         */
        clearUnreadCount: function () {
            // Note: set to 0, as opposed to calling `.unset()` so the model
            // knows the value has been set
            this.unreadCounter.set({ numUnread: 0 });
            this.all.items.syncReadPosition();
        },
    });

    return Notifications;
});

